/* ===== Inner Dragon — Product Card shared script =====
 * מחליף את הסקריפט שהודפס בעבר בתוך כל כרטיס מוצר (card-product.liquid).
 * עובד בשיטת event delegation — מאזין אחד לכל הדף, כולל כרטיסים שנטענים ב-Ajax
 * (כנראה תאהבי גם / השלימי את הסט / סינון בקולקציות).
 *
 * תאימות לאחור: כרטיס עם data-pcard-ready="true" אותחל ע"י הסקריפט הישן
 * (אם עדיין קיים inline) — הקובץ הזה מדלג עליו כדי למנוע טיפול כפול.
 *
 * v6: מהירות ובהירות בדפוס הפרימיום (SKIMS/Zara/Lululemon):
 * (א) פידבק אופטימי — ✓ על המידה ברגע הטאפ, לפני הרשת;
 * (ב) Bundled Section Rendering — add.js מחזיר את ה-HTML של עגלת
 *     הצד באותה תשובה. סיבוב רשת אחד במקום שלושה, החלפה כירורגית
 *     של .drawer__content ופתיחה ישירה דרך drawer.show().
 *     בועות הכותרת מתעדכנות ברקע ('cart:updated', לא 'cart:refresh'
 *     שגורם לרינדור כפול). מסלול גיבוי לזרימה הישנה נשמר.
 *
 * v5: מגירה בלי כפתור — המידות הן הפעולה והפידבק. טאפ על מידה
 * מוסיף לסל: המידה מהבהבת בטעינה, מתמלאת בשחור עם ✓, והמגירה
 * נסגרת לתוך פתיחת העגלה. שגיאת רשת = שורת הודעה + ניסיון חוזר
 * בטאפ נוסף. נשמרת תאימות לאחור לכפתור __atc אם קיים במרקאפ ישן.
 *
 * v3: הוספה לסל מדברת Sleek שוטף — אירוע cart:refresh עם open:true
 * (המגירה מתרעננת ונפתחת במנגנון של התבנית עצמה), עדכון בועת
 * cart-count הנכונה, והוסרו שאריות Dawn (סקשנים שלא קיימים בתבנית).
 *
 * v2: הוסרו אנימציות ה-peek (קפיצת הרמז ברצועת התמונות ובשורת המידות),
 * וחישוב הנקודות תומך RTL.
 */
(function () {
  'use strict';
  if (window.__IDS_PCARD_BOOTED) return;
  window.__IDS_PCARD_BOOTED = true;

  /* ───────────────────────── helpers ───────────────────────── */

  function getCard(el) {
    return el.closest('[data-card-id]');
  }

  function isLegacy(card) {
    return !!(card && card.getAttribute('data-pcard-ready') === 'true');
  }

  function isLegacyDrawer(drawer) {
    var cardId = drawer.getAttribute('data-card');
    if (!cardId) return false;
    var card = document.querySelector('[data-card-id="' + cardId + '"]');
    return isLegacy(card);
  }

  function drawerFor(card) {
    // לפני teleport המגירה בתוך הכרטיס; אחרי teleport — לפי ID גלובלי
    var d = card.querySelector('.pcard-size-drawer');
    if (d) return d;
    return document.getElementById('pcard-drawer-' + card.getAttribute('data-card-id'));
  }

  function resetDrawerFeedback(drawer) {
    if (!drawer) return;
    drawer.removeAttribute('data-loading');
    drawer.querySelectorAll('.pcard-size-btn').forEach(function (b) {
      b.classList.remove('loading', 'success');
    });
    var msg = drawer.querySelector('.pcard-size-drawer__msg');
    if (msg) { msg.textContent = ''; msg.setAttribute('hidden', ''); }
    /* תאימות לאחור: אם כפתור הוספה ישן עדיין קיים במרקאפ ישן */
    var atcBtn = drawer.querySelector('.pcard-size-drawer__atc');
    if (atcBtn) {
      atcBtn.disabled = true;
      atcBtn.textContent = 'הוספה לסל';
      atcBtn.classList.remove('success', 'loading');
    }
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('open');
    var backdrop = document.getElementById('pcard-backdrop-' + drawer.getAttribute('data-card'));
    if (backdrop) {
      backdrop.classList.remove('visible');
      setTimeout(function () { backdrop.style.display = 'none'; }, 300);
    }
    drawer.removeAttribute('data-selected-variant');
    drawer.querySelectorAll('.pcard-size-btn.selected').forEach(function (b) {
      b.classList.remove('selected');
    });
    resetDrawerFeedback(drawer);
  }

  function closeAllDrawers(except) {
    document.querySelectorAll('.pcard-size-drawer.open').forEach(function (d) {
      if (d !== except && !isLegacyDrawer(d)) closeDrawer(d);
    });
  }

  function teleportDrawer(drawer) {
    if (drawer.getAttribute('data-teleported') === 'true' || window.innerWidth >= 768) return;
    drawer.setAttribute('data-teleported', 'true');
    var backdrop = document.createElement('div');
    backdrop.className = 'pcard-drawer-backdrop';
    backdrop.id = 'pcard-backdrop-' + drawer.getAttribute('data-card');
    document.body.appendChild(backdrop);
    backdrop.addEventListener('click', function () { closeDrawer(drawer); });
    document.body.appendChild(drawer);
  }

  function openDrawer(drawer) {
    teleportDrawer(drawer);
    closeAllDrawers(drawer);
    drawer.classList.add('open');
    var backdrop = document.getElementById('pcard-backdrop-' + drawer.getAttribute('data-card'));
    if (backdrop && window.innerWidth < 768) {
      backdrop.style.display = 'block';
      requestAnimationFrame(function () { backdrop.classList.add('visible'); });
    }
  }

  /* ─────────────────────── click delegation ─────────────────────── */

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!(target instanceof Element)) return;

    // 1. כפתור "בחירת אפשרויות" על הכרטיס
    var trigger = target.closest('.pcard-trigger-btn');
    if (trigger) {
      var card = getCard(trigger);
      if (!card || isLegacy(card)) return; // ישן — מטופל ע"י inline
      e.preventDefault();
      var drawer = drawerFor(card);
      if (!drawer) return;
      if (drawer.classList.contains('open')) closeDrawer(drawer);
      else openDrawer(drawer);
      return;
    }

    // 2. כפתור סגירה במגירה
    var closeBtn = target.closest('.pcard-size-drawer__close');
    if (closeBtn) {
      var d1 = closeBtn.closest('.pcard-size-drawer');
      if (d1 && !isLegacyDrawer(d1)) closeDrawer(d1);
      return;
    }

    // 3. בחירת מידה
    var sizeBtn = target.closest('.pcard-size-btn');
    if (sizeBtn) {
      var d2 = sizeBtn.closest('.pcard-size-drawer');
      if (!d2 || isLegacyDrawer(d2)) return;
      if (sizeBtn.classList.contains('soldout')) return;
      d2.querySelectorAll('.pcard-size-btn.selected').forEach(function (b) {
        b.classList.remove('selected');
      });
      sizeBtn.classList.add('selected');
      d2.setAttribute('data-selected-variant', sizeBtn.getAttribute('data-variant-id') || '');
      /* v5: המידה היא ההוספה — והיא גם הפידבק (טעינה → ✓) */
      addVariant(d2, sizeBtn);
      return;
    }

    // 4. הוספה לסל מתוך המגירה
    var atcBtn = target.closest('.pcard-size-drawer__atc');
    if (atcBtn) {
      var d3 = atcBtn.closest('.pcard-size-drawer');
      if (!d3 || isLegacyDrawer(d3)) return;
      addVariant(d3, atcBtn);
      return;
    }

    // 5. לחיצה מחוץ למגירה פתוחה — סגירה
    document.querySelectorAll('.pcard-size-drawer.open').forEach(function (d) {
      if (isLegacyDrawer(d)) return;
      if (d.contains(target)) return;
      // לא לסגור אם נלחץ כפתור הטריגר של אותה מגירה (טופל בענף 1)
      closeDrawer(d);
    });
  });

  /* ─────────────────────── add to cart ─────────────────────── */

  function showDrawerError(drawer, text) {
    var msg = drawer.querySelector('.pcard-size-drawer__msg');
    if (!msg) {
      /* רשת ביטחון: אם המרקאפ הישן עדיין באוויר — יוצרים את שורת ההודעה */
      msg = document.createElement('div');
      msg.className = 'pcard-size-drawer__msg';
      msg.setAttribute('role', 'status');
      drawer.appendChild(msg);
    }
    msg.textContent = text;
    msg.removeAttribute('hidden');
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer[data-section-id]');
  }

  /* החלפה כירורגית של תוכן עגלת הצד מ-HTML שחזר מהשרת —
     אותה שיטה כמו refreshDrawer בעגלה: רק .drawer__content מוחלף,
     האוברליי וכפתור הסגירה נשארים אלמנטים מקוריים עם ה-listeners */
  function swapCartDrawer(html) {
    var current = getCartDrawer();
    if (!current || !html) return false;
    var tmp = new DOMParser().parseFromString(html, 'text/html');
    var fresh = tmp.querySelector('cart-drawer');
    if (!fresh) return false;
    var freshContent = fresh.querySelector('.drawer__content');
    var curContent = current.querySelector('.drawer__content');
    if (freshContent && curContent) curContent.innerHTML = freshContent.innerHTML;
    else current.innerHTML = fresh.innerHTML;
    return true;
  }

  /* עדכון בועות הסל בכותרת ברקע — אחרי שהעגלה כבר באוויר.
     בכוונה לא cart:refresh: הוא גורם ל-Sleek לרנדר את המגירה
     פעם נוספת (רינדור כפול + מרוץ מול הסגירה). */
  function syncHeaderSoft() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        var d = getCartDrawer();
        ['.cart-count', '.cart-count-bubble', '[data-cart-count]', '.cart__count'
        ].forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            if (d && d.contains(el)) return; /* בתוך המגירה — כבר טרי */
            el.textContent = count;
            if (count > 0) el.removeAttribute('hidden');
          });
        });
        if (count > 0) document.documentElement.classList.add('cart-has-items');
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cart, source: 'pcard-shared' }
        }));
      })
      .catch(function () {});
  }

  function addVariant(drawer, fb) {
    var selectedVariantId = drawer.getAttribute('data-selected-variant');
    if (!selectedVariantId) return;
    if (drawer.getAttribute('data-loading') === '1') return;

    drawer.setAttribute('data-loading', '1');
    var msg = drawer.querySelector('.pcard-size-drawer__msg');
    if (msg) msg.setAttribute('hidden', '');
    /* פידבק אופטימי: ה-✓ מופיע ברגע הטאפ, הרשת משלימה ברקע */
    if (fb) fb.classList.add('success');

    var cartEl = getCartDrawer();
    var sectionId = cartEl ? cartEl.getAttribute('data-section-id') : null;

    /* Bundled Section Rendering: ה-HTML של עגלת הצד חוזר
       באותה תשובה של ההוספה — סיבוב רשת אחד במקום שלושה */
    var payload = { id: parseInt(selectedVariantId, 10), quantity: 1 };
    if (sectionId) {
      payload.sections = sectionId;
      payload.sections_url = '/';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-failed');
        return res.json();
      })
      .then(function (data) {
        var swapped = false;
        if (sectionId && data && data.sections && data.sections[sectionId]) {
          swapped = swapCartDrawer(data.sections[sectionId]);
        }
        closeDrawer(drawer);
        if (swapped) {
          var d = getCartDrawer();
          if (d && !d.hasAttribute('open') && typeof d.show === 'function') {
            try { d.show(); } catch (err) {}
          }
          syncHeaderSoft();
        } else {
          /* מסלול גיבוי (אין sections בתשובה): המנגנון הישן של התבנית */
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: { cart: cart, open: true }
              }));
            })
            .catch(function () {});
        }
      })
      .catch(function () {
        drawer.removeAttribute('data-loading');
        if (fb) fb.classList.remove('success');
        showDrawerError(drawer, 'משהו השתבש, נסי שוב');
      });
  }

  /* ────────────── image strip: dots (scroll, capture phase) ────────────── */
  /* תומך RTL: scrollLeft שלילי בדפדפנים מודרניים כשהכיוון rtl — לכן Math.abs */

  document.addEventListener('scroll', function (e) {
    var strip = e.target;
    if (!(strip instanceof Element)) return;
    if (!strip.classList || !strip.classList.contains('pcard-images-strip')) return;
    var card = getCard(strip);
    if (isLegacy(card)) return;
    var dotsContainer = card ? card.querySelector('.pcard-dots') : null;
    if (!dotsContainer) return;
    var index = Math.round(Math.abs(strip.scrollLeft) / strip.offsetWidth);
    dotsContainer.querySelectorAll('.pcard-dot').forEach(function (d, i) {
      d.classList.toggle('active', i === index);
    });
  }, { capture: true, passive: true });
})();